<footer class="tw-mt-6 tw-border-t tw-border-oab-line tw-bg-white">
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-px-6 tw-py-3 tw-text-xs tw-text-oab-muted">
    <span>© Conselho Federal da OAB</span>
    <span class="tw-text-slate-400">v{{ version }}</span>
  </div>
</footer>
